/*Sticky Header JS Starts*/
jQuery(window).scroll(function()
{
    /* affix after scrolling 100px */
    if ($(document).scrollTop() > 0) {
        //jQuery('.new-header').addClass('menu_scroll');
    } else {
        //jQuery('.new-header').removeClass('menu_scroll');
    }
});
/*Sticky Header JS Ends*/


/*Links Section JS Starts*/
jQuery(document).ready(function(){

    jQuery(".link-box").mouseenter(function()
    {
        jQuery(this).removeClass("active");
        jQuery(this).addClass("active");
    });

    jQuery(".link-box").mouseout(function()
    {
        jQuery(this).removeClass("active");
    });

});
/*Links Section JS Ends*/

/*Header Top Class Starts*/
jQuery(document).ready(function(){

    jQuery(".navbar-item.has-mega-menu").hover(function()
    {
        if(jQuery('.mega-menu__section').hasClass('is-active'))
        {
            jQuery('.new-header').removeClass("active-mega");
            jQuery('.new-header').addClass("active-mega");
        }
        else
        {
            jQuery('.new-header').removeClass("active-mega");
        }
    });

});
/*Header Top Class Ends*/


/*Newsletter Modal JS Starts*/
jQuery(document).ready(function(){

    jQuery(".close").click(function(){
        $('#exampleModal').modal('hide')
        /*jQuery(".accordions-left ul li").removeClass("active");
         jQuery(this).addClass("active");*/
    });

    jQuery(".header-popup-link").click(function(){
        jQuery("body").addClass("active");
        /*jQuery(body).removeClass("active");*/
    });
  

  jQuery(".men-close").click(function(){
    $(this).closest('ul.mobile-menu__list').find('input').prop("checked", false);
  });

});
/*Newsletter Modal JS Ends*/
